import React from 'react';
import { symbol, symbolStar } from 'd3-shape';
import { metrics, colors } from './settings.js';

const star = symbol().type(symbolStar)();

export default function Map(props) {
  if (props.recomputePaths) {
    props.map.outline.d = props.path(props.map.outline)
    props.map.states.features.forEach(state => {
      state.d = props.path(state)
    })
  }
  return (
    <svg
      id='map'
      width={props.width}
      height={props.height}
      onClick={() => props.setChartGeo('United States')}
      onTouchEnd={() => {
        props.setChartGeo('United States');
        props.closeTooltip();
      }}
    >
      <g
        transform={`
          translate(${props.width / 2}, ${props.height / 2})
          matrix(${props.rotation.matrix})
          translate(${-props.width / 2}, ${-props.height / 2})
        `}
      >
      <path
        id='background-states'
        transform={`translate(
          ${props.rotation.bg.x / props.scale}, ${props.rotation.bg.y / props.scale})
        `}
        fill={colors.grey.darkest}
        d={props.map.outline.d}
      />
      <g id='foreground-states'>
        {
          props.map.states.features.map(s => {
            let fill = colors.grey.lightest;
            if (
              (
                props.tooltip
                  &&
                props.tooltip.level === 'state'
                  &&
                props.tooltip.key === s.properties.NAME
              )
                ||
              props.chart.geo === s.properties.NAME
            ) {
              fill = colors.grey.dark;
            }
            return (
              <path
                key={s.properties.NAME}
                id={s.properties.NAME}
                fill={fill}
                stroke={colors.grey.dark}
                strokeWidth={(1 / props.scale)}
                d={s.d}
                onMouseOver={props.openTooltip({
                  key: s.properties.NAME,
                  level: 'state',
                  values: [],
                })}
                onMouseOut={(e) => {
                  e.stopPropagation();
                  props.closeTooltip();
                }}
                onClick={(e) => {
                  e.stopPropagation();
                  props.setChartGeo(e.target.id);
                }}
                onTouchEnd={(e) => {
                  e.stopPropagation();
                  props.closeTooltip();
                  props.setChartGeo(e.target.id);
                }}
              />
            )
          })
        }
      </g>
      <g id='state-capitals'>
      {
        props.capitals.map(c => {
          let fill = colors.grey.light;
          if (
            (
              props.tooltip
                &&
              props.tooltip.level === 'state'
                &&
              props.tooltip.key === c.state
            )
              ||
            props.chart.geo === c.state
          ) {
            fill = colors.grey.darkest;
          }
          return (
            <path
              key={c.name}
              id={c.name}
              fill={fill}
              d={star}
              pointerEvents='none'
              transform={`translate(${c.projected}) scale(${(0.8 / props.scale)})`}
            />
          )
        })
      }
      </g>
      <g id='flier-location-points'>
        {
          !props.stacks.ready ? (
            metrics.levels.map(l => {
              return props.data[l].map(d => {
                return (
                  <rect
                    ref={p => props.stacks.refs[l][d.key] = p}
                    key={d.key}
                    id={d.key}
                    width={1}
                    height={1}
                    fill='black'
                    stroke='none'
                    transform={d.projected ? `translate(${d.projected})` : null}
                  />
                )
              })
            })
          ) : ''
        }
      </g>
      </g>
    </svg>
    );
}